require('./contractRetailLoanView.scss');
require('./contractRetailLoanView.override.scss');

const PropTypes = require('prop-types');

//@vendor
const React = require('react');
const { connect } = require('react-redux');
// @common
const { OKBreadcrumb } = require('commonsComponents/OKBreadcrumb');
//@actions
const SegmentedLoanActions = require('../../actions/segmentedLoanProducts');
const ContractRetailLoanActions = require('../../actions/contractRetailLoan');
const blockedAccountsActions = require('actions/blockedAccounts');
const SignaturePattern = require('actions/signaturePattern.js');
const actionsAccount = require('actions/accounts');
//@core
const { formatText, FormattedText } = require('core/i18n').i18n;
//@components
const { LoadingSection } = require('commonsComponents/loadingSection');
const ContractRetailLoan = require('../../components/contracts/contractRetailLoan/contractRetailLoan');
const RetailLoanCatalog = require('../../components/contracts/contractRetailLoan/retailLoanCatalog/retailLoanCatalog');
const RetailLoanInterstitialModal = require('../../components/contracts/contractRetailLoan/retailLoanInterstitialModal/retailLoanInterstitialModal');
const LoansError = require('components/loansAndMortgages/loans/loansError/loansError');
//@constants
const {
    LOGO_OPEN_DIGITAL_MARKETS,
    RETAIL_LOAN_CONSENTS_ID,
    RETAIL_LOAN_CONSENTS_STATUS,
    retailLoanDoTaggin: {
        NAME_PAGE_WIZARD_VIEW
    }
} = require('../../loansConstants');

const {
    OPEN_MARKETS_PERSONAL_DATA_INTERSTICIAL,
    RETAIL_LOAN_WAFFER,
 } = require('constants/flagBasedFeatures');
//@Utilities
const {
    recordLinkV2,
    PROC_START,
    PROC_STEP,
} = require('utilities/tagging');
//@helpers
const { buildLoadStepRetailLoanInfo } = require('../../loansUtilities/loansHelper');

class ContractRetailLoanView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            sendEventModalInterstitial: true
        }
        this.changeBillingAddress = this.changeBillingAddress.bind(this);
        this.onHandleSelectedAccount = this.onHandleSelectedAccount.bind(this);
        this.setVisibleStep = this.setVisibleStep.bind(this);
        this.onHandleUpdateRetailConsents = this.onHandleUpdateRetailConsents.bind(this);
        this.handleBreadcrumUrlClick = this.handleBreadcrumUrlClick.bind(this);
    }

    componentDidMount() {
        const {
            match: { params: { id } },
            setRetailLoanCatalogItemId,
            getConsentStatus,
            immFlagBasedFeatures,
            validateBlockedAccount
         } = this.props;

        if (!immFlagBasedFeatures.get(RETAIL_LOAN_WAFFER)) {
            window.location.href = "/myprofile/loans-mortgages/";
        } 

        if (id) {
            setRetailLoanCatalogItemId({ itemId: id });
        }
        validateBlockedAccount();
        getConsentStatus();
    }

    componentDidUpdate() {
        const {
            match: { params: { id } },
            resetLoanPorpuse,
            immRetailLoan,
            getConsentStatus
        } = this.props;

        if (!id) {
            resetLoanPorpuse();
        }

        if (immRetailLoan.get("acceptInterstitialConsentsStatus") === null && !immRetailLoan.get("hasErrorConsentsStatus")) {
            getConsentStatus();
        }
    }

    componentWillUnmount() {
        const { updatePersonalData, resetLoadCatalogItem, resetCheckModal, resetErrorStatus } = this.props;
        const personalData = {
            typeOfRoads: 0,
            streetName: '',
            numberStreet: '',
            restOfAddress: '',
            locality: '',
            postalCode: '',
            province: 0
        };
        updatePersonalData({ prop: 'personalData', personalData });
        resetLoadCatalogItem();
        resetCheckModal();
        resetErrorStatus();
    }

    setVisibleStep(visibleStep) {
        this.props.setVisibleStep({ visibleStep })
    }

    onHandleSelectedAccount(accountId) {
        this.props.setSelectedAccount({ accountId });
    }

    changeBillingAddress(typeAddress) {
        this.props.changeBillingAddress({ typeAddress });
    }

    buildBreadcrumbConfig(itemTitle) {
        return [
            {
                text: formatText('breadcrumb-breadcrumb_retailLoan'),
                url: '/myprofile/loans-mortgages/contract-retail-loan',
                onLinkClick: this.handleBreadcrumUrlClick
            },
            {
                text: itemTitle
            }
        ];
    }

    handleBreadcrumUrlClick() {
        const { immRetailLoan, immSegmented } = this.props;
        const purpose = immRetailLoan.get('purpose');
        const hasPurpose = purpose !== '';
        const showsInfoProduct = immRetailLoan.get('showInfoProduct');
        const isFetching = immRetailLoan.get('isFetching') || immSegmented.get('isFetching') || immRetailLoan.get("isFetchingStatusConsent");
        const retailLoanNotAvailable = immRetailLoan.get('isNotAvailable');
        const success = immRetailLoan.get('success');

        if (!isFetching && retailLoanNotAvailable || success || (hasPurpose && !showsInfoProduct) && !immRetailLoan.get("hasErrorConsentsStatus")) {
            const selectedItemId = immRetailLoan.get('purpose');
            const immProducts = immRetailLoan.get('products');
            const immSelectedItem = immProducts.find(immItem => selectedItemId === immItem.get('nid'));
            const visibleStep = immRetailLoan.get('visibleStep');
            const customData = {
                categoriaEvento: NAME_PAGE_WIZARD_VIEW,
                accionEvento: '/myprofile/loans-mortgages/contract-retail-loan',
                etiquetaEvento: immSelectedItem.get('title'),
                pasoProceso: visibleStep === 1 ? PROC_START : PROC_STEP + visibleStep,
                ...buildLoadStepRetailLoanInfo(immRetailLoan, visibleStep),
            };

            recordLinkV2(customData);
        }
    }

    onHandleUpdateRetailConsents() {
        const { updateUserConsent } = this.props;
        const consents = [
            {
                consentCellId: RETAIL_LOAN_CONSENTS_ID.INTERSTITIAL_CONSENT_ID,
                status: RETAIL_LOAN_CONSENTS_STATUS.ACCEPTED
            }
        ];
        updateUserConsent(consents);
    }


    buildModalInterstitial(showModal) {
        const {
            immRetailLoan,
            setInterstitialValue,
        } = this.props;

        const {
            sendEventModalInterstitial
        } = this.state;

        return (
            <RetailLoanInterstitialModal
                showModal={showModal}
                sendEventModalInterstitial={sendEventModalInterstitial}
                acceptConsentsValue={immRetailLoan.get('acceptInterstitialConsentsValue')}
                handleUpdateRetailConsents={this.onHandleUpdateRetailConsents}
                handleChangeInterstitialValue={setInterstitialValue}
                isUpdatingUserConsent={immRetailLoan.get('isUpdatingUserConsent')}
                hasErrorUpdatingUser={immRetailLoan.get('hasErrorUpdatingUser')}
                hasErrorConsentsStatus={immRetailLoan.get('hasErrorConsentsStatus')}
            />
        );
    }

    buildHeader(immRetailLoan) {
        const purpose = immRetailLoan.get('purpose');
        const error = immRetailLoan.get('isNotAvailable');

        let breadcrumb;
        let contentTopSpaceClass = '';
        let logoFixedClass = '';
        let hiddenClass = '';
        let colorRed = '';

        if (purpose !== '' || error) {
            const immProducts = immRetailLoan.get('products');
            const immSelectedItem = immProducts.find(immItem => purpose === immItem.get('nid'));
            const itemTitle = !!immSelectedItem ? immSelectedItem.get('title') : '';
            const mapping = this.buildBreadcrumbConfig(itemTitle);
            breadcrumb = <OKBreadcrumb mapping={mapping} dark={false} />;
            contentTopSpaceClass = 'contract-retail-loan-view__header-content--top-space';
            logoFixedClass = 'contract-retail-loan-view__header-content-logo--fixed';
            hiddenClass = 'hidden';
            colorRed = '--color-red';
        }

        return (
            <div className="contract-retail-loan-view__header">
                {breadcrumb}
                <div className={`contract-retail-loan-view__header-content ${contentTopSpaceClass}`}>
                    <FormattedText
                        value="retailLoan-retailLoan_title"
                        className={`contract-retail-loan-view__header-content-title${colorRed}`}
                    />
                    <FormattedText
                        value="retailLoan-retailLoan_subtitle"
                        className={`contract-retail-loan-view__header-content-subtitle ${hiddenClass}`}
                    />
                </div>
            </div>
        );
    }


    buildContent() {
        const {
            changeDeliveryAddressValue,
            getBlockedAccounts,
            immAccounts,
            immFlagBasedFeatures,
            immProfile,
            immRetailLoan,
            updatePersonalData,
            immSegmented,
            setPurpose,
            showInfoProduct,
            setDeliveryDate,
            getSegmentedLoanProducts,
            reset,
            resetBlockedAccounts,
            setAgree,
            setAgreeThirdStep,
            formalize,
            setTerm,
            onDownloadDocument,
            onDownloadDocumentTermCondition,
            onPrintDocument,
            setEmail,
            setRetailLoanAccountsInactive,
            processRequestConfiguration,
            downloadPreContractDocument,
            downloanRetailLoanContractDocument,
            downloadINEDocument,
            getProposition,
            segmentedLoanProductsReset,
            setGift,
            setInstructions,
            setDedication,
            setPickup,
            getAsnefValidation,
            getHiringDocuments,
            getTermConditionDocuments,
            validateAgreeCheckBoxModal,
            validateAgreeCheckBox,
            resetDocumentsAndAgreeCheckBox,
            resetAgreeThirdStep,
            getInfoDestinationAccount,
            resetLoanPorpuse,
            validateStep,
            checkReadDocument,
            checkCheckedDocument
        } = this.props;

        const formHandlers = {
            handleGiftOptionChange: setGift,
            handleInstructionsChange: setInstructions,
            handleDedicationChange: setDedication,
            handlePickClick: setPickup
        }

        let content;
        const purpose = immRetailLoan.get('purpose');
        const hasPurpose = purpose !== '';
        const showsInfoProduct = immRetailLoan.get('showInfoProduct');
        const isFetching = immRetailLoan.get('isFetching') || immSegmented.get('isFetching') || immRetailLoan.get("isFetchingStatusConsent");
        const retailLoanNotAvailable = immRetailLoan.get('isNotAvailable');
        const success = immRetailLoan.get('success');

        if (isFetching) {
            content = <LoadingSection />;
        } else if (retailLoanNotAvailable || success || (hasPurpose && !showsInfoProduct) && !immRetailLoan.get("hasErrorConsentsStatus")) {
            content = (
                <div className="contract-retail-loan-view__content">
                    <ContractRetailLoan
                        changeDeliveryAddressValue={changeDeliveryAddressValue}
                        getBlockedAccounts={getBlockedAccounts}
                        getHiringDocuments={getHiringDocuments}
                        getProposition={getProposition}
                        immAccounts={immAccounts}
                        immFlagBasedFeatures={immFlagBasedFeatures}
                        immProfile={immProfile}
                        immRetailLoan={immRetailLoan}
                        immSegmented={immSegmented}
                        reset={reset}
                        resetBlockedAccounts={resetBlockedAccounts}
                        showInfoProduct={showInfoProduct}
                        setEmail={setEmail}
                        setVisibleStep={this.setVisibleStep}
                        validateStep={validateStep}
                        onDownloadDocument={onDownloadDocument}
                        onPrintDocument={onPrintDocument}
                        setAgreeThirdStep={setAgreeThirdStep}
                        formalize={formalize}
                        formHandlers={formHandlers}
                        updatePersonalData={updatePersonalData}
                        setTerm={setTerm}
                        setRetailLoanAccountsInactive={setRetailLoanAccountsInactive}
                        setSelectedAccount={this.onHandleSelectedAccount}
                        processRequestConfiguration={processRequestConfiguration}
                        downloadPreContractDocument={downloadPreContractDocument}
                        downloanRetailLoanContractDocument={downloanRetailLoanContractDocument}
                        downloadINEDocument={downloadINEDocument}
                        segmentedLoanProductsReset={segmentedLoanProductsReset}
                        getAsnefValidation={getAsnefValidation}
                        resetAgreeThirdStep={resetAgreeThirdStep}
                        getInfoDestinationAccount={getInfoDestinationAccount}
                        resetLoanPorpuse={resetLoanPorpuse}
                        changeBillingAddress={this.changeBillingAddress}
                        checkReadDocument={checkReadDocument}
                        checkCheckedDocument={checkCheckedDocument}
                    />
                </div>
            );
        } else {
            const interstitialConsentStatus = immRetailLoan.get('acceptInterstitialConsentsStatus');
            const userAcceptConsents = interstitialConsentStatus === RETAIL_LOAN_CONSENTS_STATUS.ACCEPTED;
            const showModal = immFlagBasedFeatures.get(OPEN_MARKETS_PERSONAL_DATA_INTERSTICIAL) && ((!userAcceptConsents && interstitialConsentStatus !== null) || immRetailLoan.get("hasErrorConsentsStatus"));
            const interstitialModal = showModal && this.buildModalInterstitial(showModal);

            if (showModal && this.state.sendEventModalInterstitial) {
                this.setState({
                    sendEventModalInterstitial: false
                });
            }

            content = (
                <React.Fragment>

                    {!showModal ?

                        <RetailLoanCatalog
                            getSegmentedLoanProducts={getSegmentedLoanProducts}
                            getTermConditionDocuments={getTermConditionDocuments}
                            immAccounts={immAccounts}
                            immRetailLoan={immRetailLoan}
                            immSegmented={immSegmented}
                            onDownloadDocumentTermCondition={onDownloadDocumentTermCondition}
                            onPrintDocument={onPrintDocument}
                            resetDocumentsAndAgreeCheckBox={resetDocumentsAndAgreeCheckBox}
                            resetLoanPorpuse={resetLoanPorpuse}
                            setAgree={setAgree}
                            setDeliveryDate={setDeliveryDate}
                            setPurpose={setPurpose}
                            setRetailLoanAccountsInactive={setRetailLoanAccountsInactive}
                            showInfoProduct={showInfoProduct}
                            validateAgreeCheckBox={validateAgreeCheckBox}
                            validateAgreeCheckBoxModal={validateAgreeCheckBoxModal}
                        />


                        : interstitialModal

                    }

                </React.Fragment>
            );
        }

        return content;
    }

    render() {
        const {
            immRetailLoan,
            hiringProductBanners
        } = this.props;

        const isAccountBlockedValidationFetching = hiringProductBanners.get('isAccountBlockedValidationFetching');
        const isAccountBlockedValidationError = hiringProductBanners.get('isAccountBlockedValidationError');
        const header = this.buildHeader(immRetailLoan);
        const content = this.buildContent();

        return (
            <div className="grid-view contract-retail-loan-view">
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-positive">
                            <div className="col-xs-12">
                                {
                                    isAccountBlockedValidationFetching ?
                                        <div className="contract-pre-granted-credit-view__loading"><LoadingSection /></div>
                                    :
                                        isAccountBlockedValidationError ?
                                            <div><LoansError /></div>
                                        :
                                            <>
                                                {header}
                                                {content}
                                            </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ContractRetailLoanView.propTypes = {
    changeBillingAddress: PropTypes.func.isRequired,
    changeDeliveryAddressValue: PropTypes.func.isRequired,
    downloadPreContractDocument: PropTypes.func.isRequired,
    downloadINEDocument: PropTypes.func.isRequired,
    downloanRetailLoanContractDocument: PropTypes.func.isRequired,
    formalize: PropTypes.func.isRequired,
    getAsnefValidation: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    getConsentStatus: PropTypes.func.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    getInfoDestinationAccount: PropTypes.func.isRequired,
    getProposition: PropTypes.func.isRequired,
    getSegmentedLoanProducts: PropTypes.func.isRequired,
    getTermConditionDocuments: PropTypes.func.isRequired,
    hiringProductBanners: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immRetailLoan: PropTypes.object.isRequired,
    immSegmented: PropTypes.object.isRequired,
    onDownloadDocument: PropTypes.func.isRequired,
    onDownloadDocumentTermCondition: PropTypes.func.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    processRequestConfiguration: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetAgreeThirdStep: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func.isRequired,
    resetDocumentsAndAgreeCheckBox: PropTypes.func.isRequired,
    resetLoadCatalogItem: PropTypes.func.isRequired,
    resetLoanPorpuse: PropTypes.func.isRequired,
    resetCheckModal: PropTypes.func.isRequired,
    resetErrorStatus: PropTypes.func.isRequired,
    segmentedLoanProductsReset: PropTypes.func.isRequired,
    setAgree: PropTypes.func.isRequired,
    setAgreeThirdStep: PropTypes.func.isRequired,
    setDedication: PropTypes.func.isRequired,
    setDeliveryDate: PropTypes.func.isRequired,
    setEmail: PropTypes.func.isRequired,
    setGift: PropTypes.func.isRequired,
    setInstructions: PropTypes.func.isRequired,
    setInterstitialValue: PropTypes.func.isRequired,
    setPickup: PropTypes.func.isRequired,
    setPurpose: PropTypes.func.isRequired,
    setRetailLoanAccountsInactive: PropTypes.func.isRequired,
    setRetailLoanCatalogItemId: PropTypes.func.isRequired,
    setSelectedAccount: PropTypes.func.isRequired,
    setTerm: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    showInfoProduct: PropTypes.func.isRequired,
    updatePersonalData: PropTypes.func.isRequired,
    updateUserConsent: PropTypes.func.isRequired,
    validateBlockedAccount: PropTypes.func.isRequired,
    validateAgreeCheckBox: PropTypes.func.isRequired,
    validateAgreeCheckBoxModal: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
};

module.exports = connect(state => ({
    hiringProductBanners: state.hiringProductBanners,
    immAccounts: state.accounts,
    immFlagBasedFeatures: state.flagBasedFeatures,
    immProfile: state.profile,
    immRetailLoan: state.contractRetailLoan,
    immSegmented: state.segmentedLoanProducts
}), {
    changeBillingAddress: ContractRetailLoanActions.simpleActions.retailLoanChangeBillingAddress,
    changeDeliveryAddressValue: ContractRetailLoanActions.simpleActions.retailLoanChangeDeliveryAddressValue,
    downloadPreContractDocument: ContractRetailLoanActions.downloadPreContractDocument,
    downloadINEDocument: ContractRetailLoanActions.downloadINEDocument,
    downloanRetailLoanContractDocument: ContractRetailLoanActions.downloanRetailLoanContractDocument,
    formalize: ContractRetailLoanActions.formalize,
    getAsnefValidation: ContractRetailLoanActions.getAsnefValidation,
    getBlockedAccounts: blockedAccountsActions.getBlockedAccounts,
    getHiringDocuments: ContractRetailLoanActions.getHiringDocuments,
    getInfoDestinationAccount: ContractRetailLoanActions.getInfoDestinationAccount,
    getProposition: ContractRetailLoanActions.getProposition,
    getSegmentedLoanProducts: SegmentedLoanActions.getSegmentedLoanProducts,
    getTermConditionDocuments: ContractRetailLoanActions.getTermConditionDocuments,
    getConsentStatus: ContractRetailLoanActions.getConsentStatus,
    onDownloadDocument: ContractRetailLoanActions.onDownloadDocument,
    onDownloadDocumentTermCondition: ContractRetailLoanActions.onDownloadDocumentTermCondition,
    onPrintDocument: ContractRetailLoanActions.onPrintDocument,
    processRequestConfiguration: SignaturePattern.processRequestConfiguration,
    reset: ContractRetailLoanActions.simpleActions.retailLoanResetState,
    resetAgreeThirdStep: ContractRetailLoanActions.simpleActions.retailLoanResetAgreeThirdStep,
    resetBlockedAccounts: blockedAccountsActions.resetBlockedAccounts,
    resetDocumentsAndAgreeCheckBox: ContractRetailLoanActions.simpleActions.retailLoanResetDocumentAndAgreeCheckbox,
    resetLoadCatalogItem: ContractRetailLoanActions.simpleActions.retailLoanResetCatalogItem,
    resetLoanPorpuse: ContractRetailLoanActions.simpleActions.retailLoanResetPurpose,
    resetCheckModal: ContractRetailLoanActions.simpleActions.retailLoanResetAgreeCheckboxModal,
    resetErrorStatus: ContractRetailLoanActions.simpleActions.retailLoanResetErrorsStatus,
    segmentedLoanProductsReset: SegmentedLoanActions.simpleActions.segmentedLoanProductsReset,
    setAgree: ContractRetailLoanActions.simpleActions.retailLoanSetAgree,
    setAgreeThirdStep: ContractRetailLoanActions.simpleActions.retailLoanSetAgreeThirdStep,
    setDedication: ContractRetailLoanActions.simpleActions.retailLoanSetDedication,
    setDeliveryDate: ContractRetailLoanActions.simpleActions.retailLoanSetDeliveryDate,
    setEmail: ContractRetailLoanActions.simpleActions.retailLoanChangeEmail,
    setGift: ContractRetailLoanActions.simpleActions.retailLoanSetGift,
    setInstructions: ContractRetailLoanActions.simpleActions.retailLoanSetInstructions,
    setInterstitialValue: ContractRetailLoanActions.setInterstitialValue,
    setPickup: ContractRetailLoanActions.simpleActions.retailLoanSetPickup,
    setPurpose: ContractRetailLoanActions.simpleActions.retailLoanSetPurpose,
    setRetailLoanAccountsInactive: ContractRetailLoanActions.simpleActions.retailLoanSetAccountsInactive,
    setRetailLoanCatalogItemId: ContractRetailLoanActions.simpleActions.retailLoanSetCatalogItemId,
    setSelectedAccount: ContractRetailLoanActions.retailLoanSetAccount,
    setTerm: ContractRetailLoanActions.setTerm,
    setVisibleStep: ContractRetailLoanActions.simpleActions.retailLoanSetVisibleStep,
    showInfoProduct: ContractRetailLoanActions.simpleActions.retailLoanSetShowProduct,
    updatePersonalData: ContractRetailLoanActions.simpleActions.retailLoanUpdatePersonalData,
    updateUserConsent: ContractRetailLoanActions.updateUserConsent,
    validateBlockedAccount: actionsAccount.validateBlockedAccount,
    validateAgreeCheckBox: ContractRetailLoanActions.simpleActions.retailLoanValidateAgreeCheckbox,
    validateAgreeCheckBoxModal: ContractRetailLoanActions.simpleActions.retailLoanValidateAgreeCheckboxModal,
    validateStep: ContractRetailLoanActions.validateStep,
    checkReadDocument: ContractRetailLoanActions.checkReadDocument,
    checkCheckedDocument: ContractRetailLoanActions.checkCheckedDocument,

})(ContractRetailLoanView);
